import React, { useState } from 'react';
import { ChevronDown, Stethoscope, Wrench, Settings } from 'lucide-react';
export function ServicesPreview() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const services = [{
    icon: Stethoscope,
    title: 'Engineer Callout & Diagnostics',
    description: 'Our qualified engineer will visit your property to assess your appliance, identify the fault, and provide a clear explanation of what needs to be done. This includes a thorough inspection and diagnostic report.'
  }, {
    icon: Wrench,
    title: 'Repair Visit (Labour Only)',
    description: 'Following diagnostics, our engineer will carry out the necessary repairs to restore your appliance to working order. This service covers labour only; any required parts will be quoted separately and with your approval.'
  }, {
    icon: Settings,
    title: 'Service & Maintenance Visit',
    description: 'Regular maintenance helps prevent breakdowns and extends appliance life. Our service visit includes cleaning, testing, and minor adjustments to keep your appliances running efficiently and safely.'
  }];
  return <section className="py-16 bg-gray-50" data-id="element-313">
      <div className="max-w-4xl mx-auto px-4" data-id="element-314">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-gray-900" data-id="element-315">
          Our Repair Services
        </h2>
        <p className="text-center text-gray-600 mb-12 text-lg" data-id="element-316">
          Professional diagnostics, repairs, and maintenance for all major
          appliances
        </p>
        <div className="space-y-4" data-id="element-317">
          {services.map((service, index) => <div key={index} className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-318">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors" data-id="element-319">
                <div className="flex items-center gap-4" data-id="element-320">
                  <div className="w-12 h-12 bg-[#0D7377] bg-opacity-10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-321">
                    <service.icon className="text-[#0D7377]" size={24} data-id="element-322" />
                  </div>
                  <h3 className="font-semibold text-lg text-gray-900" data-id="element-323">
                    {service.title}
                  </h3>
                </div>
                <ChevronDown className={`text-[#0D7377] transition-transform ${openIndex === index ? 'rotate-180' : ''}`} size={24} data-id="element-324" />
              </button>
              {openIndex === index && <div className="px-6 pb-5 pt-2" data-id="element-325">
                  <p className="text-gray-600 leading-relaxed pl-16" data-id="element-326">
                    {service.description}
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}